export default {"src":"/_next/static/media/logo.a0b93c6a.svg","height":1024,"width":1024};